var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('b-breadcrumb',{attrs:{"items":_vm.items}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }